import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { InputBackOffice } from '../../../components/common/InputBackoffice';
import { ErrorToast } from '../../../components/common/Toasts/Toasts';
import { FlexCenter } from '../../../styles/stylesStyled';
import { Title } from './WithdrawStyled';
import { useTranslation } from 'react-i18next';
import { P3 } from '../../../styles/FontStyles';
import { editUserWallet } from '../../../slices/wallets-slice';
import { useAppDispatch } from '../../../app/hooks';
import { Button } from '../../../components';

interface EditBankAccountProps {
  account: any;
  setIsOpen4: Dispatch<SetStateAction<boolean>>;
}

export const EditBankAccount = ({
  account,
  setIsOpen4
}: EditBankAccountProps) => {
  const { t } = useTranslation('earnings');
  const dispatch = useAppDispatch();

  const [label, setLabel] = useState('');

  useEffect(() => {
    if (account) {
      setLabel(account.label || '');
    }
  }, [account]);

  return (
    <div style={{ marginTop: !setIsOpen4 ? '12vh' : '' }}>
      <Title>{t('withdraw_part.edit_bank_account.title')}</Title>

      <P3 mb='8' bold>
        {t('withdraw_part.add_bank_account.walletLabel')}
      </P3>

      <InputBackOffice
        placeholder={t('withdraw_part.add_bank_account.placeholderLabel')}
        style={{ marginBottom: 16 }}
        value={label}
        onChange={(e: string) => setLabel(e)}
      />

      <FlexCenter style={{ flexDirection: 'column' }}>
        <Button
          onClick={() => {
            if (!label) {
              ErrorToast(
                t('withdraw_part.add_bank_account.err_label_required')
              );
            } else {
              dispatch(editUserWallet({ id: account?.id, label, setIsOpen4 }));
            }
          }}
          mt='30'
          maxWidth='200px'>
          {t('withdraw_part.edit_bank_account.edit')}
        </Button>
      </FlexCenter>
    </div>
  );
};
